<template>
  <div class="schedule">
    <div>
      <div class="menu-title-right">
        <router-link v-if="prevMonth" class="box" :to="prevMonth.route">{{prevMonth.name}}</router-link>
        <span v-if="prevMonth">{{schedule.month | momentFormat('MMM')}} </span>
        <router-link  v-if="prevMonth" class="box" :to="nextMonth.route">{{nextMonth.name}}</router-link>
      </div>
      <h2>Schedule</h2>
      <loading-state :state="state"></loading-state>
      <div v-if="schedule != null">
        <div>
          <ul class="fullwidth-menu">
            <li
              class="link"
              v-for="day in schedule.days"
              v-if="day.matchesCount > 0"
              :class="{active: activeDay && activeDay.isSame(day.day)}"
              @click="activeDay = day.day"
              :key="day.$index">
              {{day.day | momentFormat('ddd Do')}}
            </li>
          </ul>
        </div>
        <section class="schedule-days"
        v-for="day in schedule.days"
        v-if="day.matchesCount > 0 && activeDay && activeDay.isSame(day.day)"
        :key="day.$index">
          <h3>{{day.day | momentFormat('dddd, MMMM Do')}}</h3>
          <div class="sub-content" :class="(forSport == 'cricket') ? 'cricket': ''">
            <div class="item compact link" v-for="match in day.allMatches" :key="match.$index">
              <workflow-football-match-mini v-if="match.sport.isFootball" :forDate="day.day" :match="match" :showDate="false" :showSport="true"></workflow-football-match-mini>
              <kabaddi-match-mini v-if="match.sport.isKabaddi && forSport == 'kabaddi'" :forDate="day.day" :match="match" :showDate="false" :showSport="true"></kabaddi-match-mini>
              <workflow-cricket-match-mini v-if="match.sport.isCricket" :forDate="day.day" :match="match" :showDate="false" :showSport="true"></workflow-cricket-match-mini>
            </div>
          </div>
        </section>
        <section v-if="activeDay === null">
          <div>Select a date to view schedule</div>
        </section>
      </div>

    </div>
  </div>
</template>

<script>
import 'intersection-observer'
import moment from 'moment'
import { SportsKind } from '@/models/core'
import { Schedule } from '@/models/schedule'
import { CricketSeason } from '@/models/cricket/season'
import { DataState, AppState } from '@/state'
import MatchMini from '@/components/workflow/cricket/MatchMini.vue'
import FootballMatchMini from '@/components/workflow/football/MatchMini.vue'

export default {
  name: 'home',
  components: {
    'WorkflowCricketMatchMini': MatchMini,
    'WorkflowFootballMatchMini': FootballMatchMini
  },
  props: {
    forSport: {
      type: String,
      default: null
    },
    forTournament: {
      type: Boolean,
      default: false
    },
    forRoute: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      monthDirection: 0,
      activeDay: null,
      schedule: null,
      monthKey: null,
      prevMonth: null,
      nextMonth: null,
      state: DataState.newLoading()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.month !== from.params.month) {
        this.monthDirection = 1
        if (to.params.month) {
          const tomonth = to.params.month + '-01'
          let frommonth = moment().format('YYYY-MM-DD')
          if (from.params.month) {
            frommonth = from.params.month + '-01'
          }
          if (moment(tomonth).isBefore(frommonth)) {
            this.monthDirection = -1
          }
        }
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    },
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.monthKey = this.$route.params.month
      this.state.changeToLoading()
      let fetchFn = null
      let forSport = this.forSport
      let tournamentKey = this.$route.params.key
      if (forSport) {
        let forTournament = this.forTournament
        if (SportsKind.Cricket.value === forSport && forTournament) {
          fetchFn = CricketSeason.schedule(tournamentKey, this.monthKey)
        } else if (SportsKind.Cricket.value === forSport) {
          fetchFn = Schedule.cricketMonth(this.monthKey)
        }
      }

      if (fetchFn === null) {
        fetchFn = Schedule.month(this.monthKey)
      }
      fetchFn.then(schedule => {
        this.schedule = schedule

        const prevMonthDate = this.schedule.month.clone().add(-1, 'months')
        const nextMonthDate = this.schedule.month.clone().add(1, 'months')
        this.prevMonth = {
          name: prevMonthDate.format('MMM'),
          route: { name: 'WorkflowCricketSchedule', params: { month: prevMonthDate.format('YYYY-MM') } }
        }

        this.nextMonth = {
          name: nextMonthDate.format('MMM'),
          route: { name: 'WorkflowCricketSchedule', params: { month: nextMonthDate.format('YYYY-MM') } }
        }

        if (forSport && SportsKind.Cricket.value === forSport) {
          this.prevMonth.route.params.key = tournamentKey
          this.nextMonth.route.params.key = tournamentKey
          this.prevMonth.route.name = 'cricketSeasonSchedule'
          this.nextMonth.route.name = 'cricketSeasonSchedule'
        } else {
          this.prevMonth.route.name = 'WorkflowCricketSchedule'
          this.nextMonth.route.name = 'WorkflowCricketSchedule'
        }
        // this.prevMonth = this.schedule.month.clone().add(-1, 'months')
        // this.nextMonth = this.schedule.month.clone().add(1, 'months')
        this.identifyActiveDay()
        this.state.changeToLoaded()
      })
    },

    identifyActiveDay () {
      const today = new Date()
      let lastDay = null
      let firstDay = null
      for (let i = 0; i < this.schedule.days.length; i++) {
        if (this.schedule.days[i].matchesCount > 0) {
          const day = this.schedule.days[i].day
          if (firstDay === null) {
            firstDay = day
          }

          lastDay = day
          const couldBeActive = (day.isSame(today, 'day') || day.isAfter(today, 'day')) && (day.isSame(today, 'month'))
          if (this.activeDay === null && day && couldBeActive) {
            this.activeDay = day
            break
          }
        }
      }

      if (this.activeDay === null) {
        if (this.monthDirection > 0 && firstDay !== null) {
          this.activeDay = firstDay
        } else {
          this.activeDay = lastDay
        }
      }
    },
    prepareToReopen () {
      this.activeDay = null
      this.schedule = null
      this.monthKey = null
      this.prevMonth = null
      this.nextMonth = null
    },
    refreshView () {

    },
    onElementVisible (entries, observer) {
    }
  }
}
</script>
